import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { map, take } from 'rxjs';

import { FeatureFlagModule } from '@mimecast-ui/shared/data-access-core/feature-flags';
import { ConfigService } from '@mimecast-ui/universal-login/data-access-config';

import { getLaunchDarklyClientIdForGrid } from './client-id.helper';

/**
 * Provides the LaunchDarkly client ID and context for MUL, derived from
 * ConfigService.grid once the login config has loaded. Shared by app.config.ts
 * and its spec so the two cannot drift out of sync.
 */
export function provideMulFeatureFlags(): EnvironmentProviders {
  return importProvidersFrom(
    FeatureFlagModule.setup({
      clientId: {
        useFactory: (configService: ConfigService) =>
          configService.configLoaded$.pipe(
            take(1),
            map(() => getLaunchDarklyClientIdForGrid(configService.grid))
          ),
        deps: [ConfigService],
      },
      config: {
        useFactory: (configService: ConfigService) =>
          configService.configLoaded$.pipe(
            take(1),
            map(() => ({
              account: {
                // Anonymous context - MUL has no post-auth identity at login time.
                accountCode: 'anonymous-mul',
                region: configService.grid,
              },
            }))
          ),
        deps: [ConfigService],
      },
    })
  );
}
